import { LOCALES } from 'utils/languageUtils';

const HEADER_LABELS = Object.freeze({
  [LOCALES.ENGLISH]: {
    lang: {
      en: 'EN',
      el: 'EL',
    },
    cartButton: 'Cart',
    userButton: 'My Account',
    menuButton: 'Menu',
    backButton: 'Back',
    closeButton: 'Close Menu',
  },
  [LOCALES.GREEK]: {
    lang: {
      en: 'ΕΝ',
      el: 'ΕΛ',
    },
    cartButton: 'Καλάθι',
    userButton: 'My Account',
    menuButton: 'Μενού',
    backButton: 'Πίσω',
    closeButton: 'Κλείσιμο Μενού',
  },
});
export default HEADER_LABELS;
